// extracted by mini-css-extract-plugin
export var phone = "_1m-0";
export var phoneDragging = "_1m-1";